/**
 * 表单控件的maker的公共方法
 * wangz 
 * 2018.3.9
 */

"use strict"
import React from 'react';
import ReactDOM from 'react-dom';
import { message } from 'antd';
import { getConstByKey } from '../sgiBaseComp/SgiCommon';

/**
 * 绑定显示值
 * @param {描述信息} panelModule 
 * @param {描述信息} moduleDesc 
 * @param {数据} bdInst
 * @param {属性} formItem 
 * @param {属性} inputprops 
 */
var bindValue = function (panelModule, moduleDesc, bdInst, formItem, inputprops) {
    if (!bdInst) {
        return;
    }
    var c = moduleDesc.c;
    if (c) inputprops.defaultValue = "12112";
    // if (c) inputprops.defaultValue = panelModule.state[bdInst][c];
}

/**
 * 属性转换
 * @param {描述信息} moduleDesc 
 * @param {属性} formItem 
 * @param {属性} inputprops 
 */
var AddFormCtlCommonAttribute = function (moduleDesc, formItem, inputprops) {

    var cId = moduleDesc.cId; //cid 唯一标示
    if (cId) inputprops.id = getConstByKey(this, cId);

    var isDis = moduleDesc.isDis; //是否可用
    if (isDis) inputprops.disabled = isDis;

    var text = moduleDesc.te; //设置标签
    if (text) formItem.label = text;

    var ctlW = moduleDesc.ctlW; //控件宽度
    if (ctlW) formItem.style.width = ctlW;

    var ctlH = moduleDesc.ctlH; //控件高度
    if (ctlH) formItem.style.height = ctlH;

    var lblW = moduleDesc.lblW; //设置标签宽度  
    if (ctlW && lblW) {
        var lblWSpan = parseInt(lblW / ctlW * 24)
        var wrapperSpan = 24 - lblWSpan;
        formItem.labelCol = { span: lblWSpan }
        formItem.wrapperCol = { span: wrapperSpan }
    } else {
        formItem.labelCol = { span: 6 }
        formItem.wrapperCol = { span: 18 }
    }

    var inpPopTe = moduleDesc.inpPopTe; //提示内容
    if (inpPopTe) inputprops.placeholder = inpPopTe;

    var defVal10 = moduleDesc.defVal10; //默认内容
    if (defVal10) inputprops.defaultValue = defVal10;

    var bdText = moduleDesc.bdText; //后置内容
    if (bdText) inputprops.addonAfter = bdText;

    var alwBlk = moduleDesc.alwBlk; //是否允许为空
    if (alwBlk) formItem.required = alwBlk;

    var isHdn = moduleDesc.isHdn; //是否隐藏??没实现
    var maxL = moduleDesc.maxL; //设置字段输入的最大长度??没实现
    var minL = moduleDesc.minL; //设置字段输入的最小长度??没实

    var isLbl = moduleDesc.isLbl; //设置是否隐藏标签??没实现
    var lblAlg = moduleDesc.lblAlg; //设置标签对齐方式??没实现
    var isClp = moduleDesc.isClp; //设置是否根据内容字段进行伸展和收缩??没实现
    var msfTgt = moduleDesc.msfTgt; //设置错误信息提示位置??没实现

    // var prefix = moduleDesc.prefix;//前缀图
    // if (prefix) inputprops.prefix = prefix;
}

/**
 * 设置布局
 * @param {描述信息} moduleDesc 
 * @param {属性} formItem 
 * @param {属性} inputprops 
 */
var setFormCtlLayout = function (moduleDesc, formItem, inputprops) {


}


/**
 * 事件转换
 * @param {描述信息} moduleDesc 
 * @param {属性} formItem 
 * @param {属性} inputprops 
 */
var bindEvent = function (moduleDesc, formItem, inputprops) {
    //点击事件
    // var click = moduleDesc.$click;
    // if (click){
    inputprops.onClick = function () {
        message.info('点击事件');
    }
    // }

    //双击事件
    inputprops.onDoubleClick = function () {
        message.info('双击事件');
    }

    //onchange
    inputprops.onChange = function () {
        message.info('修改事件');
    }

    //onInput
    inputprops.onInput = function () {
        message.info('输入事件');
    }

    //onFocus
    inputprops.onFocus = function () {
        message.info('获取焦点事件');
    }

    //onBlur
    inputprops.onBlur = function () {
        message.info('焦点离开事件');
    }

    //onCopy
    inputprops.onCopy = function () {
        message.info('复制事件');
    }

    //onCut
    inputprops.onCut = function () {
        message.info('剪切事件');
    }

    //onPaste
    inputprops.onPaste = function () {
        message.info('粘贴事件');
    }
}

export { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute };



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/formCtlMK/FormCtlMKComm.js